import { render, staticRenderFns } from "./KZGComponentEdit.vue?vue&type=template&id=984fd414&scoped=true"
import script from "./KZGComponentEdit.vue?vue&type=script&lang=js"
export * from "./KZGComponentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984fd414",
  null
  
)

export default component.exports